module.exports = __webpack_public_path__ + "static/media/img1-1.e5a3d55d.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/maiz/biosense/diff/img1-1.png
// module id = 1697
// module chunks = 3